import { render, staticRenderFns } from "./CircleLoading.vue?vue&type=template&id=8564a620&scoped=true"
import script from "./CircleLoading.vue?vue&type=script&lang=js"
export * from "./CircleLoading.vue?vue&type=script&lang=js"
import style0 from "./CircleLoading.vue?vue&type=style&index=0&id=8564a620&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8564a620",
  null
  
)

export default component.exports